import Analytics from "./analytics";

window.analytics = new Analytics()

export default function() {
  document.addEventListener('DOMContentLoaded', () => {
    window.analytics.init()
  })
}
